import { render, staticRenderFns } from "./Studio.vue?vue&type=template&id=ff4c7666"
import script from "./Studio.vue?vue&type=script&lang=js"
export * from "./Studio.vue?vue&type=script&lang=js"
import style0 from "./Studio.vue?vue&type=style&index=0&id=ff4c7666&prod&lang=scss&module=true"
import style1 from "./Studio.vue?vue&type=style&index=1&id=ff4c7666&prod&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports